import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { IApplication } from '../common/IApplication'
import store from '../store'
import questionParser from './question-parser'

export default (app: IApplication) => {
  if (app.stores) {
    app.stores.forEach(storeModule => store.registerModule(storeModule.key, storeModule.module))
  }
  if (app.dependencies) {
    app.dependencies.forEach(dependency => Vue.use(dependency.plugin, dependency.options))
  }

  (<any>window).questionParser = questionParser

  if (!document.getElementById(app.elementId)) return

  const options: any = {
    el: `#${app.elementId}`,
    store: store,
    i18n: app.i18n,
    render: h => h(app.rootComponent),
    data: app.data
  }

  if (app.vueRouter) {
    options.router = app.vueRouter
    Vue.use(VueAnalytics, {
      id: 'UA-174188571-1',
      router: app.vueRouter,
      autoTracking: {
        pageviewTemplate(route) {
          return {
            page: `/classroom/${route.path}`
          }
        }
      }
    })
  }
  if (app.vuetify) {
    options.vuetify = app.vuetify
  }

  return new Vue(options)
}
